import classNames from 'classnames';
import NavbarLogicVerical from 'components/navbars/navbar-logic-vertical/NavbarLogicVertical';
import NavbarLogic from 'components/navbars/navbar-logic/NavbarLogic';
import { useAssessmentLayoutContext } from 'providers/AssessmentLayoutProvider';
import React from 'react';
import { Outlet } from 'react-router-dom';

function LogicChallengeHeader() {
  const { contentClass } = useAssessmentLayoutContext();

  return (
    <>
      <NavbarLogicVerical />
      <NavbarLogic />
      <div className={classNames(contentClass, 'content')}>
        <Outlet />
      </div>
    </>
  );
}

export default LogicChallengeHeader;
